import * as React from "preact";
import { FunctionComponent } from "preact";

export interface IInput {
  keyId: string;
  isFile: boolean;
  handleChange?: (params: any) => void;
}

const FormInput: FunctionComponent<IInput> = ({ keyId, isFile, handleChange }) => {
  return (
    <input
      required
      name={keyId}
      className={isFile ? "base-form__input input input--file" : "base-form__input"}
      id={keyId}
      type={isFile ? "file" : "text"}
      accept={isFile ? "image/png, image/gif, image/jpeg" : undefined}
      onChange={isFile ? handleChange : undefined}
    ></input>
  );
};

export default FormInput;
